export default "__VITE_ASSET__B6p4xqCp__"